import React from 'react'
import Link from 'next/link'

function Socialmedia({ config }) {
    return (
        (config) ? (
            <div className="social-icons mt-1">
                <Link href={config.twitter}><a rel="noopener noreferrer" target="_blank" title="Twitter"><i className="icon icon-twitter-square w-6 h-6 mr-2"></i></a></Link>
                <Link href={config.linkedin}><a rel="noopener noreferrer" target="_blank" title="LinkedIn"><i className="icon icon-linkedin-square w-6 h-6 mr-2"></i></a></Link>
                <Link href={config.facebook}><a rel="noopener noreferrer" target="_blank" title="Facebook"><i className="icon icon-facebook-square w-6 h-6 mr-2"></i></a></Link>
                <Link href={config.instagram}><a rel="noopener noreferrer" target="_blank" title="Instagram"><i className="icon icon-instagram w-6 h-6"></i></a></Link>
            </div>
        ) : ('')
    );
}

export default Socialmedia;